import { IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CloseIcon from "@mui/icons-material/Close";
import { DrawerHeader, EmptyBox } from "../layout/RightDrawer.style";
import * as React from "react";

interface CommonDrawerHeaderProps {
  showBackButton: boolean;
  showCloseButton?: boolean;
  onBackButtonClick?: () => void;
  onCloseButtonClick?: () => void;
  title: string;
}

const CommonDrawerHeader = ({
  showBackButton,
  showCloseButton = true,
  onBackButtonClick,
  onCloseButtonClick,
  title,
}: CommonDrawerHeaderProps) => {
  return (
    <DrawerHeader>
      {showBackButton && onBackButtonClick ? (
        <IconButton data-testid="back-button" onClick={onBackButtonClick}>
          <ChevronLeftIcon fontSize="large" />
        </IconButton>
      ) : (
        <EmptyBox />
      )}
      <Typography variant="h6">{title}</Typography>
      {showCloseButton && onCloseButtonClick ? (
        <IconButton data-testid="close-button" onClick={onCloseButtonClick}>
          <CloseIcon />
        </IconButton>
      ) : (
        <EmptyBox />
      )}
    </DrawerHeader>
  );
};

export default CommonDrawerHeader;
